export default __webpack_public_path__ + "static/media/55mm water dispenser cap.9ab4a8ff.jpeg";